// Theme configuration for Home dashboard
// Defines six distinct visual themes with elegant pastel colors

const themes = {

  // Dark Themes
  darkMidnight: {
    id: 'darkMidnight',
    name: 'Midnight Blue',
    description: 'Deep dark blue',
    icon: '🌙',
    styles: {
      appBar: {
        background: '#1e293b',
      },
      container: {
        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
        minHeight: '100vh',
      },
      pageTitle: {
        color: 'white',
        fontWeight: 600,
      },
      pageDescription: {
        //color: '#94a3b8',
        color: 'white',
      },
      card: {
        background: 'rgba(30, 41, 59, 0.8)',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.3)',
        borderRadius: '12px',
        border: '1px solid rgba(96, 165, 250, 0.2)',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0 8px 24px rgba(96, 165, 250, 0.3)',
          transform: 'translateY(-2px)',
          background: 'rgba(30, 41, 59, 0.95)',
          border: '1px solid rgba(96, 165, 250, 0.4)',
        },
      },
      cardTitle: {
        color: '#e2e8f0',
        fontWeight: 600,
      },
      cardDescription: {
        color: '#94a3b8',
      },
    },
  },

  darkForest: {
    id: 'darkForest',
    name: 'Forest Night',
    description: 'Dark green forest',
    icon: '🌲',
    styles: {
      appBar: {
        background: '#1a3d2e',
      },
      container: {
        background: 'linear-gradient(135deg, #0a2e1f 0%, #1a3d2e 100%)',
        minHeight: '100vh',
      },
      pageTitle: {
        color: '#4ade80',
        fontWeight: 600,
      },
      pageDescription: {
        color: '#86efac',
      },
      card: {
        background: 'rgba(26, 61, 46, 0.8)',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.3)',
        borderRadius: '12px',
        border: '1px solid rgba(74, 222, 128, 0.2)',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0 8px 24px rgba(74, 222, 128, 0.3)',
          transform: 'translateY(-2px)',
          background: 'rgba(26, 61, 46, 0.95)',
          border: '1px solid rgba(74, 222, 128, 0.4)',
        },
      },
      cardTitle: {
        color: '#d1fae5',
        fontWeight: 600,
      },
      cardDescription: {
        color: '#86efac',
      },
    },
  },

  darkPurple: {
    id: 'darkPurple',
    name: 'Purple Haze',
    description: 'Dark purple night',
    icon: '🌌',
    styles: {
      appBar: {
        // background: '#312e81',
        background: '#16143fff',
      },
      container: {
        //background: 'linear-gradient(135deg, #7d77caff 0%, #8985f1ff 100%)',
        //background:'white',
        background: 'linear-gradient(135deg, #211f3fff 0%, #8985f1ff 100%)',
        minHeight: '100vh',
      },
      pageTitle: {
        //color: '#c084fc',
        color: 'white',
        fontWeight: 600,
      },
      pageDescription: {
        //color: '#d8b4fe',
        color: 'white',
      },
      card: {
        background: 'rgba(27, 26, 66, 0.8)',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.3)',
        borderRadius: '12px',
        border: '1px solid rgba(192, 132, 252, 0.2)',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0 8px 24px rgba(192, 132, 252, 0.3)',
          transform: 'translateY(-2px)',
          background: 'rgba(49, 46, 129, 0.95)',
          border: '1px solid rgba(192, 132, 252, 0.4)',
        },
      },
      cardTitle: {
        // color: '#e9d5ff',
        color: 'white',
        fontWeight: 600,
      },
      cardDescription: {
        //color: '#d8b4fe',
        color: 'white',
      },
    },
  },

  darkCharcoal: {
    id: 'darkCharcoal',
    name: 'Charcoal Gray',
    description: 'Elegant dark gray',
    icon: '⚫',
    styles: {
      appBar: {
        background: '#27272a',
      },
      container: {
        background: 'linear-gradient(135deg, #18181b 0%, #27272a 100%)',
        minHeight: '100vh',
      },
      pageTitle: {
        color: '#a1a1aa',
        fontWeight: 600,
      },
      pageDescription: {
        color: '#71717a',
      },
      card: {
        background: 'rgba(39, 39, 42, 0.8)',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.4)',
        borderRadius: '12px',
        border: '1px solid rgba(161, 161, 170, 0.2)',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0 8px 24px rgba(161, 161, 170, 0.3)',
          transform: 'translateY(-2px)',
          background: 'rgba(39, 39, 42, 0.95)',
          border: '1px solid rgba(161, 161, 170, 0.4)',
        },
      },
      cardTitle: {
        color: '#e4e4e7',
        fontWeight: 600,
      },
      cardDescription: {
        color: '#a1a1aa',
      },
    },
  },

  // Soft/Neutral Themes
  softBeige: {
    id: 'softBeige',
    name: 'Soft Beige',
    description: 'Warm neutral beige',
    icon: '🤎',
    styles: {
      appBar: {
        background: '#a8a29e',
      },
      container: {
        background: 'linear-gradient(135deg, #f5f1ed 0%, #ebe5df 100%)',
        minHeight: '100vh',
      },
      pageTitle: {
        color: '#78716c',
        fontWeight: 600,
      },
      pageDescription: {
        color: '#a8a29e',
      },
      card: {
        background: 'rgba(255, 255, 255, 0.7)',
        boxShadow: '0 3px 12px rgba(120, 113, 108, 0.1)',
        borderRadius: '12px',
        border: '1px solid rgba(120, 113, 108, 0.15)',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0 6px 20px rgba(120, 113, 108, 0.2)',
          transform: 'translateY(-2px)',
          background: 'rgba(255, 255, 255, 0.9)',
        },
      },
      cardTitle: {
        color: '#57534e',
        fontWeight: 600,
      },
      cardDescription: {
        color: '#78716c',
      },
    },
  },

  softGray: {
    id: 'softGray',
    name: 'Soft Gray',
    description: 'Cool neutral gray',
    icon: '🩶',
    styles: {
      appBar: {
        background: '#6b7280',
      },
      container: {
        background: 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)',
        minHeight: '100vh',
      },
      pageTitle: {
        color: '#4b5563',
        fontWeight: 600,
      },
      pageDescription: {
        color: '#6b7280',
      },
      card: {
        background: 'rgba(255, 255, 255, 0.8)',
        boxShadow: '0 3px 12px rgba(75, 85, 99, 0.1)',
        borderRadius: '12px',
        border: '1px solid rgba(75, 85, 99, 0.15)',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0 6px 20px rgba(75, 85, 99, 0.2)',
          transform: 'translateY(-2px)',
          background: 'rgba(255, 255, 255, 0.95)',
        },
      },
      cardTitle: {
        color: '#374151',
        fontWeight: 600,
      },
      cardDescription: {
        color: '#6b7280',
      },
    },
  },

  // using pastal color theme
  modernMinimalist: {
    id: 'modernMinimalist',
    name: 'Soft Lavender',
    description: 'Elegant pastel purple',
    icon: '🌸',
    styles: {
      appBar: {
        background: '#8b7ba8',
      },
      container: {
        background: 'linear-gradient(135deg, #f5f0ff 0%, #e8dff5 100%)',
        minHeight: '100vh',
      },
      pageTitle: {
        color: '#6b4c9a',
        fontWeight: 600,
        letterSpacing: '0.5px',
      },
      pageDescription: {
        color: '#8b7ba8',
        fontWeight: 400,
      },
      card: {
        background: 'rgba(255, 255, 255, 0.85)',
        boxShadow: '0 2px 8px rgba(107, 76, 154, 0.1)',
        borderRadius: '12px',
        border: '1px solid rgba(107, 76, 154, 0.15)',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0 6px 20px rgba(107, 76, 154, 0.2)',
          transform: 'translateY(-2px)',
          background: 'rgba(255, 255, 255, 0.95)',
        },
      },
      cardTitle: {
        color: '#6b4c9a',
        fontWeight: 600,
      },
      cardDescription: {
        color: '#8b7ba8',
      },
    },
  },

  glassmorphism: {
    id: 'glassmorphism',
    name: 'Mint Dream',
    description: 'Fresh pastel mint',
    icon: '🍃',
    styles: {
      appBar: {
        background: '#4a9999',
      },
      container: {
        background: 'linear-gradient(135deg, #d4f1f4 0%, #b8e6e0 100%)',
        minHeight: '100vh',
      },
      pageTitle: {
        color: '#2d7a7a',
        fontWeight: 600,
        textShadow: '0 2px 4px rgba(45, 122, 122, 0.1)',
      },
      pageDescription: {
        color: '#4a9999',
      },
      card: {
        background: 'rgba(255, 255, 255, 0.75)',
        backdropFilter: 'blur(10px)',
        boxShadow: '0 4px 16px rgba(45, 122, 122, 0.15)',
        border: '1px solid rgba(45, 122, 122, 0.2)',
        borderRadius: '12px',
        transition: 'all 0.3s ease',
        '&:hover': {
          background: 'rgba(255, 255, 255, 0.9)',
          boxShadow: '0 6px 24px rgba(45, 122, 122, 0.25)',
          transform: 'translateY(-2px)',
        },
      },
      cardTitle: {
        color: '#2d7a7a',
        fontWeight: 600,
      },
      cardDescription: {
        color: '#4a9999',
      },
    },
  },

  darkTheme: {
    id: 'darkTheme',
    name: 'Peach Blossom',
    description: 'Warm pastel peach',
    icon: '🍑',
    styles: {
      appBar: {
        background: '#d97a5e',
      },
      container: {
        background: 'linear-gradient(135deg, #ffe5d9 0%, #ffd4c4 100%)',
        minHeight: '100vh',
      },
      pageTitle: {
        color: '#c85a3e',
        fontWeight: 600,
      },
      pageDescription: {
        color: '#d97a5e',
      },
      card: {
        background: 'rgba(255, 255, 255, 0.8)',
        boxShadow: '0 3px 12px rgba(200, 90, 62, 0.12)',
        borderRadius: '12px',
        border: '1px solid rgba(200, 90, 62, 0.15)',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0 6px 20px rgba(200, 90, 62, 0.2)',
          transform: 'translateY(-2px)',
          background: 'rgba(255, 255, 255, 0.95)',
        },
      },
      cardTitle: {
        color: '#c85a3e',
        fontWeight: 600,
      },
      cardDescription: {
        color: '#d97a5e',
      },
    },
  },

  gradientColorful: {
    id: 'gradientColorful',
    name: 'Sky Blue',
    description: 'Serene pastel blue',
    icon: '☁️',
    styles: {
      appBar: {
        background: '#5a9bc5',
      },
      container: {
        background: 'linear-gradient(135deg, #e0f4ff 0%, #c9e6f7 100%)',
        minHeight: '100vh',
      },
      pageTitle: {
        color: '#3a7ca5',
        fontWeight: 600,
        textShadow: '0 2px 4px rgba(58, 124, 165, 0.1)',
      },
      pageDescription: {
        color: '#5a9bc5',
      },
      card: {
        background: 'rgba(255, 255, 255, 0.8)',
        boxShadow: '0 3px 12px rgba(58, 124, 165, 0.12)',
        borderRadius: '12px',
        border: '1px solid rgba(58, 124, 165, 0.15)',
        transition: 'all 0.3s ease',
        '&:hover': {
          background: 'rgba(255, 255, 255, 0.95)',
          boxShadow: '0 6px 20px rgba(58, 124, 165, 0.2)',
          transform: 'translateY(-2px)',
        },
      },
      cardTitle: {
        color: '#3a7ca5',
        fontWeight: 600,
      },
      cardDescription: {
        color: '#5a9bc5',
      },
    },
  },

  neumorphism: {
    id: 'neumorphism',
    name: 'Rose Garden',
    description: 'Delicate pastel pink',
    icon: '🌹',
    styles: {
      appBar: {
        background: '#d97b9a',
      },
      container: {
        background: 'linear-gradient(135deg, #ffe8f0 0%, #ffd6e5 100%)',
        minHeight: '100vh',
      },
      pageTitle: {
        color: '#c75b7a',
        fontWeight: 600,
        textShadow: '0 2px 4px rgba(199, 91, 122, 0.1)',
      },
      pageDescription: {
        color: '#d97b9a',
      },
      card: {
        background: 'rgba(255, 255, 255, 0.8)',
        boxShadow: '0 3px 12px rgba(199, 91, 122, 0.12)',
        borderRadius: '12px',
        border: '1px solid rgba(199, 91, 122, 0.15)',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0 6px 20px rgba(199, 91, 122, 0.2)',
          transform: 'translateY(-2px)',
          background: 'rgba(255, 255, 255, 0.95)',
        },
      },
      cardTitle: {
        color: '#c75b7a',
        fontWeight: 600,
      },
      cardDescription: {
        color: '#d97b9a',
      },
    },
  },

  materialDesign3: {
    id: 'materialDesign3',
    name: 'Lemon Sorbet',
    description: 'Bright pastel yellow',
    icon: '🍋',
    styles: {
      appBar: {
        background: '#d9b847',
      },
      container: {
        background: 'linear-gradient(135deg, #fff9e6 0%, #ffefc9 100%)',
        minHeight: '100vh',
      },
      pageTitle: {
        color: '#c9a227',
        fontWeight: 600,
      },
      pageDescription: {
        color: '#d9b847',
      },
      card: {
        background: 'rgba(255, 255, 255, 0.85)',
        boxShadow: '0 3px 12px rgba(201, 162, 39, 0.12)',
        borderRadius: '12px',
        border: '1px solid rgba(201, 162, 39, 0.15)',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0 6px 20px rgba(201, 162, 39, 0.2)',
          transform: 'translateY(-2px)',
          background: 'rgba(255, 255, 255, 0.95)',
        },
      },
      cardTitle: {
        color: '#c9a227',
        fontWeight: 600,
      },
      cardDescription: {
        color: '#d9b847',
      },
    },
  },

  coral: {
    id: 'coral',
    name: 'Coral Reef',
    description: 'Vibrant pastel coral',
    icon: '🪸',
    styles: {
      appBar: {
        background: '#e97575',
      },
      container: {
        background: 'linear-gradient(135deg, #ffe8e8 0%, #ffd4d4 100%)',
        minHeight: '100vh',
      },
      pageTitle: {
        color: '#d95555',
        fontWeight: 600,
      },
      pageDescription: {
        color: '#e97575',
      },
      card: {
        background: 'rgba(255, 255, 255, 0.8)',
        boxShadow: '0 3px 12px rgba(217, 85, 85, 0.12)',
        borderRadius: '12px',
        border: '1px solid rgba(217, 85, 85, 0.15)',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0 6px 20px rgba(217, 85, 85, 0.2)',
          transform: 'translateY(-2px)',
          background: 'rgba(255, 255, 255, 0.95)',
        },
      },
      cardTitle: {
        color: '#d95555',
        fontWeight: 600,
      },
      cardDescription: {
        color: '#e97575',
      },
    },
  },

  sage: {
    id: 'sage',
    name: 'Sage Green',
    description: 'Calming pastel sage',
    icon: '🌿',
    styles: {
      appBar: {
        background: '#7aa77a',
      },
      container: {
        background: 'linear-gradient(135deg, #e8f5e9 0%, #d4e9d6 100%)',
        minHeight: '100vh',
      },
      pageTitle: {
        color: '#5a8a5a',
        fontWeight: 600,
      },
      pageDescription: {
        color: '#7aa77a',
      },
      card: {
        background: 'rgba(255, 255, 255, 0.8)',
        boxShadow: '0 3px 12px rgba(90, 138, 90, 0.12)',
        borderRadius: '12px',
        border: '1px solid rgba(90, 138, 90, 0.15)',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0 6px 20px rgba(90, 138, 90, 0.2)',
          transform: 'translateY(-2px)',
          background: 'rgba(255, 255, 255, 0.95)',
        },
      },
      cardTitle: {
        color: '#5a8a5a',
        fontWeight: 600,
      },
      cardDescription: {
        color: '#7aa77a',
      },
    },
  },

  lilac: {
    id: 'lilac',
    name: 'Lilac Mist',
    description: 'Dreamy pastel lilac',
    icon: '💜',
    styles: {
      appBar: {
        background: '#a575dd',
      },
      container: {
        background: 'linear-gradient(135deg, #f3e8ff 0%, #e5d4ff 100%)',
        minHeight: '100vh',
      },
      pageTitle: {
        color: '#8855cc',
        fontWeight: 600,
      },
      pageDescription: {
        color: '#a575dd',
      },
      card: {
        background: 'rgba(255, 255, 255, 0.85)',
        boxShadow: '0 3px 12px rgba(136, 85, 204, 0.12)',
        borderRadius: '12px',
        border: '1px solid rgba(136, 85, 204, 0.15)',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0 6px 20px rgba(136, 85, 204, 0.2)',
          transform: 'translateY(-2px)',
          background: 'rgba(255, 255, 255, 0.95)',
        },
      },
      cardTitle: {
        color: '#8855cc',
        fontWeight: 600,
      },
      cardDescription: {
        color: '#a575dd',
      },
    },
  },

  cream: {
    id: 'cream',
    name: 'Vanilla Cream',
    description: 'Soft pastel cream',
    icon: '🍦',
    styles: {
      appBar: {
        background: '#b5a586',
      },
      container: {
        background: 'linear-gradient(135deg, #faf8f3 0%, #f5f0e6 100%)',
        minHeight: '100vh',
      },
      pageTitle: {
        color: '#9a8866',
        fontWeight: 600,
      },
      pageDescription: {
        color: '#b5a586',
      },
      card: {
        background: 'rgba(255, 255, 255, 0.9)',
        boxShadow: '0 3px 12px rgba(154, 136, 102, 0.12)',
        borderRadius: '12px',
        border: '1px solid rgba(154, 136, 102, 0.15)',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0 6px 20px rgba(154, 136, 102, 0.2)',
          transform: 'translateY(-2px)',
          background: 'rgba(255, 255, 255, 1)',
        },
      },
      cardTitle: {
        color: '#9a8866',
        fontWeight: 600,
      },
      cardDescription: {
        color: '#b5a586',
      },
    },
  },

  aqua: {
    id: 'aqua',
    name: 'Aqua Marine',
    description: 'Ocean pastel aqua',
    icon: '🌊',
    styles: {
      appBar: {
        background: '#26a69a',
      },
      container: {
        background: 'linear-gradient(135deg, #e0f7fa 0%, #b2ebf2 100%)',
        minHeight: '100vh',
      },
      pageTitle: {
        color: '#00838f',
        fontWeight: 600,
      },
      pageDescription: {
        color: '#26a69a',
      },
      card: {
        background: 'rgba(255, 255, 255, 0.8)',
        boxShadow: '0 3px 12px rgba(0, 131, 143, 0.12)',
        borderRadius: '12px',
        border: '1px solid rgba(0, 131, 143, 0.15)',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0 6px 20px rgba(0, 131, 143, 0.2)',
          transform: 'translateY(-2px)',
          background: 'rgba(255, 255, 255, 0.95)',
        },
      },
      cardTitle: {
        color: '#00838f',
        fontWeight: 600,
      },
      cardDescription: {
        color: '#26a69a',
      },
    },
  },

  apricot: {
    id: 'apricot',
    name: 'Apricot Sunset',
    description: 'Sweet pastel apricot',
    icon: '🌅',
    styles: {
      appBar: {
        background: '#f57c00',
      },
      container: {
        background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)',
        minHeight: '100vh',
      },
      pageTitle: {
        color: '#e65100',
        fontWeight: 600,
      },
      pageDescription: {
        color: '#f57c00',
      },
      card: {
        background: 'rgba(255, 255, 255, 0.85)',
        boxShadow: '0 3px 12px rgba(230, 81, 0, 0.12)',
        borderRadius: '12px',
        border: '1px solid rgba(230, 81, 0, 0.15)',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0 6px 20px rgba(230, 81, 0, 0.2)',
          transform: 'translateY(-2px)',
          background: 'rgba(255, 255, 255, 0.95)',
        },
      },
      cardTitle: {
        color: '#e65100',
        fontWeight: 600,
      },
      cardDescription: {
        color: '#f57c00',
      },
    },
  },


};

// Global styles for animations
const globalStyles = `
  /* No animations needed for pastel themes */
`;

export { themes, globalStyles };
